/**
 * Helper function.
 * @param {*} args Charcode.
 * @returns {string} Stringbased utf8.
 */
function fromCharCode(args: Uint8Array): string {
  const max = 16000;
  let ret = '';
  for (let i = 0; i < args.length; i += max) {
    const subArray = args.subarray(i, i + max);
    // @ts-expect-error: Uint8Array can be used here
    ret += String.fromCharCode.apply(null, subArray);
  }

  return ret;
}

/**
 * Used for wrapping widevine license.
 * @param {*} data UTF8-encoded string.
 * @returns {string} Decoded URI component.
 */
export default function fromUTF8(data: string | Uint8Array): string {
  if (!data) return '';

  // @ts-expect-error: String can be used here
  let uint8 = new Uint8Array(data);
  // If present, strip off the UTF-8 BOM.
  if (uint8[0] === 0xef && uint8[1] === 0xbb && uint8[2] === 0xbf) {
    uint8 = uint8.subarray(3);
  }

  // http://stackoverflow.com/a/13691499
  const utf8 = fromCharCode(uint8);
  // This converts each character in the string to an escape sequence.  If the
  // character is in the ASCII range, it is not converted; otherwise it is
  // converted to a URI escape sequence.
  // Example: '\x67\x35\xe3\x82\xac' -> 'g#%E3%82%AC'
  const escaped = escape(utf8);
  // Decode the escaped sequence.  This will interpret UTF-8 sequences into the
  // correct character.
  // Example: 'g#%E3%82%AC' -> 'g#€'
  return decodeURIComponent(escaped);
}
